import { render, staticRenderFns } from "./ServiceSelectItem.vue?vue&type=template&id=45f59924&scoped=true&"
import script from "./ServiceSelectItem.vue?vue&type=script&lang=js&"
export * from "./ServiceSelectItem.vue?vue&type=script&lang=js&"
import style0 from "./ServiceSelectItem.vue?vue&type=style&index=0&id=45f59924&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f59924",
  null
  
)

export default component.exports